import React from "react";
import filterConnect from "../../../../common/hoc/filterConnect";
import { Form, Input, Select } from "antd";
const IdentityDocument = ({
  form,
  labelCol,
  wrapperCol,
  identityDocuments,
  editingPersonInfo
}) => {
  const { getFieldDecorator, getFieldValue } = form;
  return (
    <>
      <Form.Item
        label="Удостоверение личности"
        labelCol={labelCol}
        wrapperCol={wrapperCol}
        style={{ marginBottom: 2 }}
      >
        {getFieldDecorator("identity_document", {
          rules: [
            {
              required: true,
              message: "Поле, обязательное для заполнения"
            }
          ]
        })(
          <Select
            placeholder="Выберите исполнителя"
            showSearch
            getPopupContainer={trigger => trigger.parentNode}
            style={{ width: 368 }}
          >
            {identityDocuments &&
              identityDocuments.map(item => {
                return (
                  <Select.Option
                    key={item.identityDocumentId}
                    value={item.identityDocumentKey}
                  >
                    {item.identityDocumentName}
                  </Select.Option>
                );
              })}
          </Select>
        )}
      </Form.Item>
      {editingPersonInfo ? (
        <>
          <Form.Item
            label="Серия"
            labelCol={{ span: 4 }}
            style={{ marginLeft: 330, marginBottom: 2 }}
            wrapperCol={{ span: 8 }}
          >
            {getFieldDecorator("identity_document_series")(
              <Input style={{ width: 224 }} placeholder={"Укажите серию"} />
            )}
          </Form.Item>
          <Form.Item
            label="Номер"
            labelCol={{ span: 4 }}
            style={{ marginLeft: 330 }}
            wrapperCol={{ span: 8 }}
          >
            {getFieldDecorator("identity_document_num")(
              <Input style={{ width: 224 }} placeholder={"Укажите номер"} />
            )}
          </Form.Item>
        </>
      ) : getFieldValue("identity_document") ? (
        <>
          <Form.Item
            label="Серия"
            labelCol={{ span: 4 }}
            style={{ marginLeft: 330, marginBottom: 2 }}
            wrapperCol={{ span: 8 }}
          >
            {getFieldDecorator("identity_document_series")(
              <Input style={{ width: 224 }} placeholder={"Укажите серию"} />
            )}
          </Form.Item>
          <Form.Item
            label="Номер"
            labelCol={{ span: 4 }}
            style={{ marginLeft: 330 }}
            wrapperCol={{ span: 8 }}
          >
            {getFieldDecorator("identity_document_num")(
              <Input style={{ width: 224 }} placeholder={"Укажите номер"} />
            )}
          </Form.Item>
        </>
      ) : null}
    </>
  );
};

export default filterConnect(IdentityDocument, ["identityDocuments"]);
